import React, {useRef, useState} from 'react';
import { useParams } from "react-router-dom";

import { useTranslation } from "core/hooks/useTranslation";
import usePermissions from 'core/hooks/usePermission';
import useRole from 'core/hooks/useRole';

import { useGlobalSelector, userInfoSelector } from "core/stores/globalStore";

import { PERMISSION_ACTION, PERMISSION_RESOURCE } from 'core/constants/permission';
import { POPUP_SIZE } from "core/constants/common";
import { USER_ROLE } from 'core/constants/auth';

import Modal from "core/ui-kit/modal";
import TabTableDashboardLayout from 'components/layouts/tab/table';
import CommissionsView from "core/global/commissions/commissionsView";
import CommissionsPopupAdd from "core/global/commissions/commissionsPopupAdd";

const Commissions = () => {
    const { t } = useTranslation();

    const searchParams = new URLSearchParams(location.search);
    const urlParams = useParams();

    const permissionUtils = usePermissions();
    const hasCreatePermission = permissionUtils.has( PERMISSION_RESOURCE.PROJECT_COMMISSION_PLAN, PERMISSION_ACTION.CREATE );
    const hasModifyPermission = permissionUtils.has( PERMISSION_RESOURCE.PROJECT_COMMISSION_PLAN, PERMISSION_ACTION.MODIFY );

    const [isAddCommissionModalOpened, setIsAddCommissionModalOpened] = useState(false);
    const [triggerKey, setTriggerKey] = useState(0);

    const [creationDisabled, setCreationDisabled] = useState(false);
    const [isFormTouched, setIsFormTouched] = useState(false);

    const { hasRole } = useRole();
    const userInfo = useGlobalSelector(userInfoSelector);

    const affiliateId = hasRole(USER_ROLE.AFFILIATE) ? userInfo.id : urlParams.id;
    const affiliateLongId = searchParams.get("longId");
    const affiliateName = searchParams.get("name");

    const _commissionsPopupAddRef = useRef(null);

    const onAssignButtonClick = () => {
        _commissionsPopupAddRef.current.onAssignButtonClick()
    }

    const openAddCommissionModal = () => {
        setIsAddCommissionModalOpened(true);
    }

    const closeAddCommissionModal = () => {
        setIsFormTouched(false);
        setIsAddCommissionModalOpened(false);
    }

    const onCommissionAssigned = () => {
        setTriggerKey(prev => ++prev);
        closeAddCommissionModal();
    }

    const headerData = {
        button: {
            icon: "plus",
            type: "primary",
            text: t("backoffice.commissionplans.addCommission"),
            enabled: hasCreatePermission,
            onClick: openAddCommissionModal,
        }
    }

    return (
        <TabTableDashboardLayout
            header={headerData}
        >
            <div className="rt--commissions-page">
                <CommissionsView
                    affiliateId={affiliateId}
                    affiliateLongId={affiliateLongId}
                    editable={hasModifyPermission}
                    triggerKey={triggerKey}
                    affiliateName={affiliateName}
                />
            </div>

            <Modal
                open={isAddCommissionModalOpened}
                title={t('backoffice.commissionplans.addCommission')}
                onCancel={closeAddCommissionModal}
                cancelText={t("backoffice.common.cancel")}
                okText={t("backoffice.common.add")}
                onOk={onAssignButtonClick}
                size={POPUP_SIZE.BIGER}
                okButtonProps={{disabled: creationDisabled || !isFormTouched}}
            >
                <CommissionsPopupAdd
                    affiliateId={affiliateId}
                    ref={_commissionsPopupAddRef}
                    onCommissionAssigned={onCommissionAssigned}
                    affiliateLongId={affiliateLongId}
                    creationDisabled={creationDisabled}
                    setCreationDisabled={setCreationDisabled}
                    setIsFormTouched={setIsFormTouched}
                />
            </Modal>
        </TabTableDashboardLayout>
    );

   
}

export default Commissions;
